import { useState } from 'react';
import GridCard from '../Finance/GridCard';
import DataTable from '../Reusable/DataTable';
import APIS from '../../constant/EndPoint';
import moment from 'moment';
import NACell from '../Reusable/DataTable/NACell';
import Modal from '../Reusable/Modal';
import Remark from '../Order/Remark';
const MerchantOnboard = (props: any) => {
  const { gridData } = props

  const reportGrid = gridData?.find((item: any) => item.slug === "merchant")
  const [cardFilterParms, setCardFilterParms] = useState<any>({})
  const [openReviewModal, setOpenReviewModal] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState("")

  const handleCardFilterParams = (key: string) => {
    let params: any = {}
    let newKey = key.replaceAll("-", "_")
    if (cardFilterParms[newKey]) {
      setCardFilterParms({ ...params })
    } else {
      params[newKey] = true
      setCardFilterParms({ ...params })
    }
  }

  let defaultColumns: any = [
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className='whitespace-nowrap'>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}</p>
          </>
        )
      },
    },
    {
      header: "Vendor",
      accessorKey: "vendor.id",
      cell: ({ getValue, row: { original } }: any) => {
        return (
          <p className="capitalize">{original?.is_walking_customer ? original?.sender_full_name : original?.merchant?.profile?.full_name}</p>
        )
      }
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: NACell
    },
    {
      header: "Destination",
      accessorKey: "destination_branch.name",
      cell: NACell
    },
    {
      header: "Customer",
      accessorKey: "customer_full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_full_address}</p>
            <p className="text-xs text-gray-500 block">{row?.original?.customer_mobile_number1}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_mobile_number2}</p>
          </>
        )
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className='whitespace-nowrap'>COD: {row?.original?.cod ?? 0} </p>
            <p className='whitespace-nowrap'>Collected: {row?.original?.collected_cod}</p>
            <p className='whitespace-nowrap'>D. Charge:{getValue()}</p>
          </>
        )
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p>{getValue()}<span className="text-gray-500 text-xs">Kgs</span> </p>
          </>
        )
      },
    },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => <button onClick={() => {
        setSelectedOrder(row?.original?.id)
        setOpenReviewModal(true)
      }}>
        {getValue()} Remarks
      </button>
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p className="uppercase">{getValue()}</p>
          </>
        )
      },
    }
  ];

  return (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8'>
        {reportGrid?.children?.map((item: any, index: number) => (
          <GridCard
            key={index}
            item={item}
            handleOpenEditPopup={()=>console.log("test")}
            onClick={handleCardFilterParams}
            selectedCardItems={cardFilterParms}
          />
        ))}
      </div>
      <DataTable
        url={APIS.OVERVIEW_ORDER}
        queryKey={"overview-order"}
        columns={defaultColumns}
        tableName={"orders"}
        isUpload={false}
        params={{ ...cardFilterParms }}
      />

<Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={<>
          <Remark
            selectedOrder={selectedOrder}
          />
        </>}
      />
    </>

  )
}

export default MerchantOnboard
